import { API_BASE_URL } from '../config';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function SeleccionManzana() {
    const navigate = useNavigate();
    const { fraccionId } = useParams();
    const [manzanas, setManzanas] = useState([]);
    const [lotesDisponibles, setLotesDisponibles] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchManzanas = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/api/manzanas/${fraccionId}`);
                if (!response.ok) {
                    throw new Error('Error al obtener las manzanas');
                }
                const data = await response.json();
                setManzanas(data);
                
                // Obtener la cantidad de lotes disponibles para cada manzana
                const lotesInfo = {};
                await Promise.all(data.map(async (manzana) => {
                    const lotesResponse = await fetch(`${API_BASE_URL}/api/lotes/manzanas/${manzana.id_manzana}`);
                    if (lotesResponse.ok) {
                        const lotesData = await lotesResponse.json();
                        lotesInfo[manzana.id_manzana] = lotesData.length;
                    }
                }));
                
                setLotesDisponibles(lotesInfo);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };
        
        fetchManzanas();
    }, [fraccionId]);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="text-xl text-gray-600">Cargando manzanas...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-red-50 p-4 rounded-lg">
                <div className="text-red-700">Error: {error}</div>
            </div>
        );
    }

    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold text-gray-800">Seleccione una Manzana</h2>
                <button 
                    onClick={() => navigate('/')}
                    className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                >
                    Volver
                </button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {manzanas.map(manzana => (
                    <div 
                        key={manzana.id_manzana}
                        onClick={() => navigate(`/lotes/${manzana.id_manzana}`)}
                        className="bg-white rounded-lg shadow-md p-6 cursor-pointer hover:shadow-lg transition-all"
                    >
                        <div className="flex items-center justify-between mb-4">
                            <div className="flex items-center justify-center w-12 h-12 bg-blue-100 rounded-full">
                                <span className="text-blue-600 font-semibold">{manzana.numero_manzana}</span>
                            </div>
                            
                            <div className="bg-blue-50 px-3 py-1 rounded-full">
                                <span className="text-blue-700 font-medium">
                                    {lotesDisponibles[manzana.id_manzana] || 0} lotes disponibles
                                </span>
                            </div>
                        </div>
                        
                        <h3 className="text-lg font-semibold text-gray-800">
                            Manzana {manzana.numero_manzana}
                        </h3>
                        
                        <p className="mt-2 text-gray-600">
                            {manzana.descripcion_manzana}
                        </p>
                        
                        <div className="mt-3">
                            <span className="inline-block px-3 py-1 bg-green-100 text-green-800 text-sm rounded-full">
                                {manzana.estado_manzana}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

/*import { API_BASE_URL } from '../config';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export default function SeleccionManzana() {
    const navigate = useNavigate();
    const { fraccionId } = useParams();
    const [manzanas, setManzanas] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchManzanas = async () => {
            try {
				const response = await fetch(`${API_BASE_URL}/api/manzanas/${fraccionId}`);
                //const response = await fetch(`http://192.168.0.3:3001/api/manzanas/${fraccionId}`);
                if (!response.ok) {
                    throw new Error('Error al obtener las manzanas');
                }
                const data = await response.json();
                setManzanas(data);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchManzanas();
    }, [fraccionId]);

    if (loading) {
        return (
            <div className="flex justify-center items-center h-64">
                <div className="text-xl text-gray-600">Cargando manzanas...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="bg-red-50 p-4 rounded-lg">
                <div className="text-red-700">Error: {error}</div>
            </div>
        );
    }

    return (
        <div className="space-y-4">
            <div className="flex items-center justify-between">
                <h2 className="text-2xl font-bold text-gray-800">Seleccione una Manzana</h2>
                <button 
                    onClick={() => navigate('/')}
                    className="px-4 py-2 text-sm bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200"
                >
                    Volver
                </button>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {manzanas.map(manzana => (
                    <div 
                        key={manzana.id_manzana}
                        onClick={() => navigate(`/lotes/${manzana.id_manzana}`)}
                        className="bg-white rounded-lg shadow-md p-6 cursor-pointer hover:shadow-lg transition-all"
                    >
                        <div className="flex items-center justify-center w-12 h-12 mb-4 bg-blue-100 rounded-full">
                            <span className="text-blue-600 font-semibold">{manzana.numero_manzana}</span>
                        </div>
                        
                        <h3 className="text-lg font-semibold text-gray-800">
                            Manzana {manzana.numero_manzana}
                        </h3>
                        
                        <p className="mt-2 text-gray-600">
                            {manzana.descripcion_manzana}
                        </p>
                        
                        <div className="mt-3">
                            <span className="inline-block px-3 py-1 bg-green-100 text-green-800 text-sm rounded-full">
                                {manzana.estado_manzana}
                            </span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}*/